import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function WishlistPage({ match }) {

  return (
    <Container
          location={{
            locationName: "Wishlist insights",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/wishlists" />
    </Container>
  );
}

export default WishlistPage;